import { Component, OnInit, LOCALE_ID, Inject } from '@angular/core';
import { DbmanagerService } from '../services/dbmanager.service';
import { Router } from '@angular/router';
import { WaitingDialogComponent } from '../shared/waiting-dialog/waiting-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import '@angular/localize/init';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-loginpage',
  templateUrl: './loginpage.component.html',
  styleUrls: ['./loginpage.component.css']
})
export class LoginpageComponent implements OnInit {

  private userSet: boolean;
  private passSet: boolean;
  public warningMessage: string;
  public rememberCred = true;

  public user = '';
  public pass = '';

  constructor(private dbservice: DbmanagerService, private router: Router,
              private dialog: MatDialog, @Inject(LOCALE_ID) protected localeId: string) {
    this.userSet = false;
    this.passSet = false;

    const user = localStorage.getItem('gwareuser');
    const pass = localStorage.getItem('gwarepass');

    if ((user !== null) && (pass != null)) {
      this.user = user;
      this.pass = pass;
      this.userSet = true;
      this.passSet = true;
      const session = sessionStorage.getItem('gwareSession');
      if (session !== null) {
        this.dbservice.logged = true;
        this.dbservice.company = sessionStorage.getItem('gwareCompany');
        this.dbservice.emailLogin(this.user, this.pass);
        this.dbservice.getUsers();
        this.router.navigateByUrl('/itemsList');
      }
    } else {
      this.rememberCred = false;
      this.user = $localize`:@@loginpage.user:Użytkownik`;
      this.pass = $localize`:@@loginpage.pass:Hasło`;
    }
   }

  ngOnInit(): void {
    this.dbservice.getUsersItems().subscribe(items => {
      if (items.has(this.user) === true) {
        if ((((Object)((items.get(this.user).EXPIRATION_DATE))).toDate()) > (new Date())) {
          this.dbservice.getData();
        } else {
          this.warningMessage = $localize`:@@loginpage.expire:Konto wygasło`;
        }
      }
    });
  }

  userFocusOut(d) {
    if (d.value.length === 0) {
      d.value = $localize`:@@loginpage.user:Użytkownik`;
      this.userSet = false;
    } else {
      this.userSet = true;
    }
    this.user = d.value ;
  }

  userChanged(d) {
    if (d.value.length > 0) {
    this.userSet = true;
    }
    this.user = d.value ;
  }

  userFocus(d) {
    if ( this.userSet === false) {
      d.value = '';
    }
  }

  passFocusOut(d) {
    if (d.value.length === 0) {
      d.value = $localize`:@@loginpage.pass:Hasło`;
      this.passSet = false;
    } else {
      this.passSet = true;
    }
    this.pass = d.value ;
  }

  passChanged(d) {
    if (d.value.length > 0) {
    this.passSet = true;
    }
    this.pass = d.value ;
  }

  passFocus(d) {
    if ( this.passSet === false) {
      d.value = '';
    }
  }

  clickLogin() {
    if (this.rememberCred) {
      localStorage.setItem('gwareuser', this.user);
      localStorage.setItem('gwarepass', this.pass);
    } else {
      localStorage.removeItem('gwareuser');
      localStorage.removeItem('gwarepass');
    }
    if ( this.userSet === false) {
      this.warningMessage = $localize`:@@loginpage.emptyuser:Proszę wypełnić pole użytkownik`;
      return;
    }

    if ( this.passSet === false) {
      this.warningMessage = $localize`:@@loginpage.setpass:Proszę wypełnić pole hasło`;
      return;
    }
    this.warningMessage = '';
    const dataDialogRef = this.dialog.open(WaitingDialogComponent,  { disableClose: true, panelClass: 'waitingclass' }) ;
    this.dbservice.emailLogin(this.user, this.pass);
    this.dbservice.getLoginStatus().subscribe( status => {
      dataDialogRef.close();
      if (status === false) {
        this.warningMessage = $localize`:@@loginpage.wrongcredentials:Nieprawidłowe dane logowania`;
      } else {
        this.dbservice.getUsers();
        sessionStorage.setItem('gwareSession', Date.now().toString());
        sessionStorage.setItem('gwareCompany', this.dbservice.company);
        this.router.navigateByUrl('/itemsList');
      }
    });
  }
}
